// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21oBP","top":"styles_top__DIPdO"};